module.exports = __webpack_public_path__ + "static/media/Dance.2fc708ea.svg";